import React from 'react';
import { Space, Typography } from 'antd';

const DataDisplay = ({ title, value, copyable = false }) => {
  return (
    <Space>
      <Typography.Text>{title}</Typography.Text>
      <Typography.Text type="secondary" copyable={copyable}>
        {' '}
        {value}{' '}
      </Typography.Text>
    </Space>
  );
};

export default DataDisplay;
